// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    background-color: #f7fafc; /* Definindo a cor de fundo da tela do navegador */
    font-family: 'Arial', sans-serif;
}
/* Layout principal para a tela Home */
.home-container {
    display: flex;
    flex-direction: column; /* Flexível em coluna para o layout */
    justify-content: flex-start;
    align-items: flex-start;
    padding: 20px;
    padding-top: 0px; /* Ajuste para o tamanho da navbar */
    background-color: #f4f7fc;
    width: 100%;
    box-sizing: border-box;
}

/* Contêiner de widgets */
.widget-container {
    display: flex;
    flex-wrap: wrap; /* Permite que os widgets se ajustem conforme a largura */
    gap: 20px; /* Espaçamento entre os widgets */
    justify-content: flex-start;
    
}

/* Estilo para o widget de informações */
.widget-info {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-family: 'Arial', sans-serif;
    width: 330px; /* Ajuste a largura para 4 widgets por linha */
    text-align: left;
    box-sizing: border-box;
    margin: 10px; /* Adiciona margem para separar os widgets */
    z-index: 2;
}


/* Estilos para os itens da lista (Código, Operador, Data) */
.widget-info .item {
    font-weight: bold;
    color: #333;
    display: block;
    margin-top: 10px;
}

.widget-info .value {
    color: #555;
}

/* Estilo para o botão */
.widget-info .button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    margin-top: 15px;
    transition: background-color 0.3s ease;
}

.widget-info .button:hover {
    background-color: #0056b3;
}

.widget-info .button:focus {
    outline: 2px solid white;
}

/* Media Queries para telas menores */
@media (max-width: 1024px) {
    .widget-info {
        width: calc(40% - 40px); /* Para telas médias, 2 blocos por linha */
    }
}

@media (max-width: 600px) {
    .widget-info {
        width: 100%; /* Para telas pequenas, 1 bloco por linha */
    }
}

/* Estilo para o modal de sobreposição */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Fundo escuro */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* Garante que o modal fique por cima de outros elementos */
    opacity: 0; /* Começa invisível */
    pointer-events: none; /* Impede a interação com o fundo quando o modal está invisível */
    transition: opacity 0.3s ease-in-out; /* Transição suave para a opacidade */
}

/* Modal visível */
.modal-overlay.open {
    opacity: 1; /* Torna o modal visível */
    pointer-events: auto; /* Permite a interação com o fundo */
}

/* Estilo para o conteúdo do modal */
.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    max-height: 80%;
    overflow-y: auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transform: translateY(-50px); /* Inicialmente, o conteúdo do modal está levemente acima */
    opacity: 0; /* Conteúdo começa invisível */
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out; /* Transição para opacidade e movimento */
}

/* Modal visível com animação suave */
.modal-overlay.open .modal-content {
    transform: translateY(0); /* O conteúdo desce para a posição normal */
    opacity: 1; /* Torna o conteúdo visível */
}

.close-button {
    background: #ff4d4d;
    border: none;
    color: white;
    padding: 8px 12px;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.3s;
    position: absolute;
    top: 10px;
    right: 10px;
}

.close-button:hover {
    background: #cc0000;
}

h2 {
    margin-bottom: 15px;
    font-size: 1.5rem;
    color: #333;
}

.modal ul {
    list-style: none;
    padding: 0;
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #ddd;
    border-radius: 5px;
    background: #f9f9f9;
    margin-bottom: 15px;
}

.modal li {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    font-size: 0.9rem;
    text-align: left;
}

.modal li:last-child {
    border-bottom: none;
}

.nova-observacao {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

textarea {
    width: 100%;
    height: 80px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1rem;
}

button {
    background: #007bff;
    border: none;
    color: white;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
    transition: background 0.3s;
}

button:hover {
    background: #0056b3;
}

.empty-message {
    text-align: center;
    color: #777;
    font-style: italic;
    padding: 10px;
}

/* Adicione ao stylesOperacao.css */
.observation-icon:hover {
  filter: brightness(1.5);
}

`, "",{"version":3,"sources":["webpack://./src/components/operacao/stylesOperacao.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,yBAAyB,EAAE,kDAAkD;IAC7E,gCAAgC;AACpC;AACA,sCAAsC;AACtC;IACI,aAAa;IACb,sBAAsB,EAAE,qCAAqC;IAC7D,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;IACb,gBAAgB,EAAE,oCAAoC;IACtD,yBAAyB;IACzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,eAAe,EAAE,yDAAyD;IAC1E,SAAS,EAAE,iCAAiC;IAC5C,2BAA2B;;AAE/B;;AAEA,wCAAwC;AACxC;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,gCAAgC;IAChC,YAAY,EAAE,8CAA8C;IAC5D,gBAAgB;IAChB,sBAAsB;IACtB,YAAY,EAAE,4CAA4C;IAC1D,UAAU;AACd;;;AAGA,4DAA4D;AAC5D;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,qCAAqC;AACrC;IACI;QACI,uBAAuB,EAAE,0CAA0C;IACvE;AACJ;;AAEA;IACI;QACI,WAAW,EAAE,2CAA2C;IAC5D;AACJ;;AAEA,wCAAwC;AACxC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,iBAAiB;IACvD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,2DAA2D;IAC1E,UAAU,EAAE,qBAAqB;IACjC,oBAAoB,EAAE,iEAAiE;IACvF,oCAAoC,EAAE,qCAAqC;AAC/E;;AAEA,kBAAkB;AAClB;IACI,UAAU,EAAE,0BAA0B;IACtC,oBAAoB,EAAE,oCAAoC;AAC9D;;AAEA,oCAAoC;AACpC;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,4BAA4B,EAAE,2DAA2D;IACzF,UAAU,EAAE,8BAA8B;IAC1C,gEAAgE,EAAE,yCAAyC;AAC/G;;AAEA,qCAAqC;AACrC;IACI,wBAAwB,EAAE,2CAA2C;IACrE,UAAU,EAAE,6BAA6B;AAC7C;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;AACzB","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n    background-color: #f7fafc; /* Definindo a cor de fundo da tela do navegador */\n    font-family: 'Arial', sans-serif;\n}\n/* Layout principal para a tela Home */\n.home-container {\n    display: flex;\n    flex-direction: column; /* Flexível em coluna para o layout */\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 20px;\n    padding-top: 0px; /* Ajuste para o tamanho da navbar */\n    background-color: #f4f7fc;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* Contêiner de widgets */\n.widget-container {\n    display: flex;\n    flex-wrap: wrap; /* Permite que os widgets se ajustem conforme a largura */\n    gap: 20px; /* Espaçamento entre os widgets */\n    justify-content: flex-start;\n    \n}\n\n/* Estilo para o widget de informações */\n.widget-info {\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    font-family: 'Arial', sans-serif;\n    width: 330px; /* Ajuste a largura para 4 widgets por linha */\n    text-align: left;\n    box-sizing: border-box;\n    margin: 10px; /* Adiciona margem para separar os widgets */\n    z-index: 2;\n}\n\n\n/* Estilos para os itens da lista (Código, Operador, Data) */\n.widget-info .item {\n    font-weight: bold;\n    color: #333;\n    display: block;\n    margin-top: 10px;\n}\n\n.widget-info .value {\n    color: #555;\n}\n\n/* Estilo para o botão */\n.widget-info .button {\n    width: 100%;\n    padding: 10px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 14px;\n    cursor: pointer;\n    margin-top: 15px;\n    transition: background-color 0.3s ease;\n}\n\n.widget-info .button:hover {\n    background-color: #0056b3;\n}\n\n.widget-info .button:focus {\n    outline: 2px solid white;\n}\n\n/* Media Queries para telas menores */\n@media (max-width: 1024px) {\n    .widget-info {\n        width: calc(40% - 40px); /* Para telas médias, 2 blocos por linha */\n    }\n}\n\n@media (max-width: 600px) {\n    .widget-info {\n        width: 100%; /* Para telas pequenas, 1 bloco por linha */\n    }\n}\n\n/* Estilo para o modal de sobreposição */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); /* Fundo escuro */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000; /* Garante que o modal fique por cima de outros elementos */\n    opacity: 0; /* Começa invisível */\n    pointer-events: none; /* Impede a interação com o fundo quando o modal está invisível */\n    transition: opacity 0.3s ease-in-out; /* Transição suave para a opacidade */\n}\n\n/* Modal visível */\n.modal-overlay.open {\n    opacity: 1; /* Torna o modal visível */\n    pointer-events: auto; /* Permite a interação com o fundo */\n}\n\n/* Estilo para o conteúdo do modal */\n.modal-content {\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    width: 400px;\n    max-height: 80%;\n    overflow-y: auto;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    transform: translateY(-50px); /* Inicialmente, o conteúdo do modal está levemente acima */\n    opacity: 0; /* Conteúdo começa invisível */\n    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out; /* Transição para opacidade e movimento */\n}\n\n/* Modal visível com animação suave */\n.modal-overlay.open .modal-content {\n    transform: translateY(0); /* O conteúdo desce para a posição normal */\n    opacity: 1; /* Torna o conteúdo visível */\n}\n\n.close-button {\n    background: #ff4d4d;\n    border: none;\n    color: white;\n    padding: 8px 12px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background 0.3s;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n}\n\n.close-button:hover {\n    background: #cc0000;\n}\n\nh2 {\n    margin-bottom: 15px;\n    font-size: 1.5rem;\n    color: #333;\n}\n\n.modal ul {\n    list-style: none;\n    padding: 0;\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    background: #f9f9f9;\n    margin-bottom: 15px;\n}\n\n.modal li {\n    padding: 10px;\n    border-bottom: 1px solid #ddd;\n    font-size: 0.9rem;\n    text-align: left;\n}\n\n.modal li:last-child {\n    border-bottom: none;\n}\n\n.nova-observacao {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\ntextarea {\n    width: 100%;\n    height: 80px;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 1rem;\n}\n\nbutton {\n    background: #007bff;\n    border: none;\n    color: white;\n    padding: 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 1rem;\n    transition: background 0.3s;\n}\n\nbutton:hover {\n    background: #0056b3;\n}\n\n.empty-message {\n    text-align: center;\n    color: #777;\n    font-style: italic;\n    padding: 10px;\n}\n\n/* Adicione ao stylesOperacao.css */\n.observation-icon:hover {\n  filter: brightness(1.5);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
